import {
  Control,
  FieldErrorsImpl,
  FieldValues,
  UseFormClearErrors,
  UseFormGetValues,
  UseFormHandleSubmit,
  UseFormRegister,
  UseFormReset,
  UseFormSetError,
  UseFormSetFocus,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form';
import { ReactNode, Dispatch, SetStateAction } from 'react';

export interface ProvideragendContasContextProps {
  children: ReactNode;
}

type SelectProps = {
  value: number;
  label: string;
}[];

export type tipoContaProps = {
  value: number;
  label: string;
};

export const tipoDtaEntrada: SelectProps = [
  { value: 0, label: 'Mês Atual' },
  { value: 1, label: 'Mês Vencimento' },
  { value: 2, label: 'Mês Anterior ao vencimento' },
];

export const tiposFrequencia: SelectProps = [
  { value: 0, label: 'Única' },
  { value: 1, label: 'Diária' },
  { value: 2, label: 'Semanal' },
  { value: 3, label: 'Mensal' },
  { value: 4, label: 'Trimestral' },
  { value: 5, label: 'Semestral' },
  { value: 6, label: 'Anual' },
];

type FormType = {
  register: UseFormRegister<FieldValues>;
  handleSubmit: UseFormHandleSubmit<FieldValues>;
  control: Control<FieldValues, any>;
  reset: UseFormReset<FieldValues>;
  setValue: UseFormSetValue<FieldValues>;
  getValues: UseFormGetValues<FieldValues>;
  watch: UseFormWatch<FieldValues>;
  setError: UseFormSetError<FieldValues>;
  clearErrors: UseFormClearErrors<FieldValues>;
  setFocus: UseFormSetFocus<FieldValues>;
  errors: FieldErrorsImpl<{ [x: string]: any }>;
};

export type formData = {
  cod_categoria: SelectProps;
  cod_cc: SelectProps;
  cod_finalizadora: SelectProps;
  cod_loja: SelectProps;
  cod_pessoa: SelectProps;
  cod_seq_agendamento?: number;
  des_observacao: string;
  dta_docto: string | Date;
  dta_termino: string | Date;
  num_dia_entrada: number;
  qtd_parcelas: number;
  tipo_dta_entrada: SelectProps;
  tipo_frequencia: SelectProps;
  val_docto: number;
  tipo_conta: number;
};

export type agendamentoDataProps = {
  insertValues: formData;
};

interface ILoja {
  des_loja: string;
  des_uf: string;
  cod_loja: number;
  des_fantasia: string;
  num_cnpj: string;
  des_cidade: string;
  cst_pis_cof_entrada: string;
  cst_pis_cof_saida: string;
  cst_pis_cof_saida_aliq_zero: string;
  cst_pis_cof_ent_aliq_zero: string;
  cst_pis_cof_saida_monof: string;
  cst_pis_cof_ent_monof: string;
  cst_pis_cof_saida_subst: string;
  cst_pis_cof_ent_subst: string;
  cst_pis_cof_saida_imune: string;
  cst_pis_cof_ent_imune: string;
  cst_pis_cof_saida_susp: string;
  cst_pis_cof_ent_susp: string;
  tipo_regime: number;
  flg_st_bc_pis_cof: boolean;
  flg_ipi_bc_pis_cof: boolean;
  tipo_integra_frente: number;
  tipo_totalizador_etq_bal: number;
  qtd_dig_cod_bal: number;
  flg_sem_dig_verif_bal: boolean;
  regra_empresa: {
    tipo_margem: number;
    tipo_custo: number;
    per_tol_custo: number;
    per_bloq_custo: number;
    per_tol_venda: number;
    per_bloq_venda: number;
  };
  parametro_nfe: {
    tipo_ambiente: number;
  };
}

export type agendContasContextData = {
  isUpdate: boolean;
  setIsUpdate: Dispatch<SetStateAction<boolean>>;
  formAgendamento: FormType;
  tipoCategoria: string;
  tipoConta: tipoContaProps;
  handleChangeTipoConta: (tipo: tipoContaProps) => void;
  contaBancoRetriever: number | null;
  setContaBancoRetriever: Dispatch<SetStateAction<number | null>>;
  lojaRetriever: number | null;
  setLojaRetriever: Dispatch<SetStateAction<number | null>>;
  handleChangeDtaTermino: () => void;
  loja: ILoja;
  disabledQtdParcela: boolean;
  handleDisableQtdParcelas: (disabled: boolean) => void;
  handleDisabledDtaTermino: (disabled: boolean) => void;
  disabledDtaTermino: boolean;
};
